import { render, staticRenderFns } from "./OmxEmpty.vue?vue&type=template&id=7a7bab11&scoped=true"
import script from "./OmxEmpty.vue?vue&type=script&lang=js"
export * from "./OmxEmpty.vue?vue&type=script&lang=js"
import style0 from "./OmxEmpty.vue?vue&type=style&index=0&id=7a7bab11&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7bab11",
  null
  
)

export default component.exports